export const DEFAULT_PAGE_SIZE = 50;

export const getPagesCount = (totalSize, sizePerPage = DEFAULT_PAGE_SIZE) => Math.ceil(totalSize / sizePerPage);
